import { useEffect, useState } from 'react';
import 'intersection-observer';
const getIsDocumentVisible = () => (typeof window !== 'undefined' ? !document.hidden : false);
export const useElementVisibility = ({ element, active, }) => {
    const [isDocumentVisible, setIsDocumentVisible] = useState(getIsDocumentVisible());
    const [isElementIntersecting, setIsElementIntersecting] = useState(false);
    const onVisibilityChange = () => setIsDocumentVisible(getIsDocumentVisible());
    useEffect(() => {
        let observer;
        if (typeof window !== 'undefined' && active !== false) {
            const options = {
                threshold: 0,
            };
            observer = new IntersectionObserver(([entry]) => setIsElementIntersecting(entry.isIntersecting), options);
            if (element.current)
                observer.observe(element.current);
            window.addEventListener('visibilitychange', onVisibilityChange, false);
        }
        return () => {
            if (observer) {
                observer.disconnect();
                window.removeEventListener('visibilitychange', onVisibilityChange);
            }
        };
    }, [element, active]);
    if (active === false) {
        return true;
    }
    return isDocumentVisible && isElementIntersecting;
};
//# sourceMappingURL=useElementVisibility.js.map